import Select, { components } from "react-select"
import styled, { css } from "styled-components"

import SVGIcon from "../../SVGIcon"

const DropdownIndicator = ({ innerRef, isFocused, ...rest }) => {
  return (
    <components.DropdownIndicator ref={innerRef} {...rest}>
      <IndicatorBlock isFocused={isFocused}>
        <SVGIcon name="caretArrowDown" />
      </IndicatorBlock>
    </components.DropdownIndicator>
  )
}

const Option = ({ innerRef, innerProps, data }) => {
  return (
    <CustomOption ref={innerRef} {...innerProps}>
      <OptionLabel>{data.label}</OptionLabel>
      {data?.subText && <OptionSubTxt>{data.subText}</OptionSubTxt>}
    </CustomOption>
  )
}

export default function SelectBox({ size = 5, ...rest }) {
  const height = window.innerWidth * ((56 * size) / 375)

  return (
    <Select
      styles={customSelectStyle}
      components={{ DropdownIndicator, Option }}
      menuPlacement="auto"
      maxMenuHeight={height}
      minMenuHeight={height}
      {...rest}
    />
  )
}

const customSelectStyle = {
  control: (provided, state) => {
    return {
      ...provided,
      display: "flex",
      border: state.isFocused ? "1px solid #FFCF19" : "1px solid #D5D5D5",
      borderRadius: "calc(100vw * (5 / 375))",
      padding: "calc(100vw * (10 / 375))",
      fontSize: "calc(100vw * (14 / 375))",
      fontWeight: "400",
      lineHeight: "calc(100vw * (17 / 375))",
      boxShadow: "none",
    }
  },
  menu: (provided) => {
    return {
      ...provided,
      border: "1px solid #FFCF19",
    }
  },
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  indicatorsContainer: () => ({
    display: "flex",
    alignItems: "center",
  }),
}

const IndicatorBlock = styled.span`
  width: calc(100vw * (15 / 375));
  height: calc(100vw * (10 / 375));

  svg {
    ${({ isFocused }) =>
      isFocused &&
      css`
        color: #ffcf19;
      `};
  }
`

const CustomOption = styled.div`
  display: flex;
  justify-content: space-between;
  padding: calc(100vw * (19 / 375)) calc(100vw * (15 / 375));
  border-bottom: 1px solid #efefef;
  height: calc(100vw * (56 / 375));
  &:last-child {
    border-bottom: none;
  }
`

const OptionLabel = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (17 / 375));
  color: #121212;
`

const OptionSubTxt = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 700;
  line-height: calc(100vw * (21 / 375));
  color: #ff9b57;
`
